<template>
    <div class="modal-header" :style="{ borderBottom: isBottomBorderShow ? '1px solid #efefef' : '', marginTop: newLoginForm ? '10px' : '' }">
        <div style=" display:flex; align-items: center; padding-left:20px; width:100px;" @click="close()" :style="{ visibility: isBackBtnHidden ? 'hidden' : '' }">
            <img :src="require('@/assets/img/back_btn_black_new.png')" v-if="icon === '' && mode === ''" style="width:15px;">
            <img :src="require('@/assets/exit.png')" v-if="icon === 'X'" style="transform: rotate(180deg); width:15px;">
            <img :src="require('@/assets/join_back.png')" v-if="icon === 'joinback'" style=" width:15px;">
            <img :src="require('@/assets/img/black_x_btn_new.png')" v-if="icon === 'Xnew'" style=" width:20px;">
        </div>
        <div style="flex:1; font-weight:bold; font-size:18px; display:grid; place-items:center;">{{ title }}</div>
        <div style="width:100px;">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: "ModalHeader",
    props: {
        title: {
            type: String,
            default: '',
        },
        isShowCompleteBtn: {
            type: Function,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        icon: {
            type: String,
            default: ''
        },
        isBottomBorderShow: {
            type: Boolean,
            default: true
        },
        isBackBtnHidden: {
            type: Boolean,
            default: false,
        },
        isCloseTwice: {
            type: Boolean,
            default: false
        },
        newLoginForm: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: ''
        }
    },
    methods: {
        close() {
            if (this.icon === 'EMPTY') return;

            if (this.isCloseTwice) {
                this.$GlobalStore.closeLastModal(true);
                this.$GlobalStore.closeLastModal(true);
            } else {
                this.$GlobalStore.closeLastModal(true);
            }

        },

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.modal-header {
    display: flex;
    height: 50px;
}
</style>